import { PieChart, Pie, Cell, Tooltip, TooltipProps } from 'recharts'
import CircleIcon from '@mui/icons-material/Circle'
import { ValueType, NameType } from 'recharts/types/component/DefaultTooltipContent'
import { IPieChartProps } from './EFCharts.model'

const COLORS = ['var(--graph-fill-latestversion)', 'var(--graph-fill-mandatoryversion)', 'var(--graph-fill-outofdate)']

const RADIAN = Math.PI / 180
const renderCustomizedLabel = ({
  cx = 0,
  cy = 0,
  midAngle = 0,
  innerRadius = 0,
  outerRadius = 0,
  percent = 0,
  index = 0
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * RADIAN)
  const y = cy + radius * Math.sin(-midAngle * RADIAN)

  if (percent === 0) {
    return null
  }
  return (
    <text
      x={x - 15}
      y={y}
      fill='black'
      fontSize={20}
      fontWeight={500}
      textAnchor={x > cx ? 'start' : 'end'}
      dominantBaseline='central'
    >
      {percent * 100 >= 10 && `${(percent * 100).toFixed(0)}%`}
    </text>
  )
}

const CustomTooltip = ({ active, payload, label }: TooltipProps<ValueType, NameType>) => {
  if (active) {
    return (
      <div className='custom-tooltip'>
        <p className='label1'>
          {' '}
          <CircleIcon style={{ color: payload?.[0].payload.fill }} />{' '}
          {`${payload?.[0].name} : ${Math.round((payload?.[0].value as number) || 0)}%`}
        </p>
      </div>
    )
  }

  return null
}

export function EFPieChart(props: IPieChartProps) {
  return (
    <PieChart
      style={{
        width: '100%',
        height: '100%'
      }}
      width={300}
      height={300}
    >
      <Pie
        startAngle={90}
        endAngle={-270}
        data={props.chartProps}
        cx='50%'
        cy='50%'
        labelLine={false}
        label={renderCustomizedLabel}
        outerRadius={150}
        fill='#8884d8'
        dataKey='value'
        animationDuration={500}
      >
        {props.chartProps.map((entry, index) => (
          <Cell
            key={`cell-${entry.name}`}
            fill={COLORS[index % COLORS.length]}
          />
        ))}
      </Pie>
      <Tooltip
        formatter={value => {
          return `${value === 'NaN' ? 0 : value} %`
        }}
        content={<CustomTooltip />}
      />
    </PieChart>
  )
}
